// extracted by mini-css-extract-plugin
module.exports = {"header":"header-39DAM","expand":"expand-DmMD-"};